import Parse from 'parse'
import Router from 'vue-router'
import Vue from 'vue'

const Dashboard = () => import(/* webpackChunkName: 'Dashboard' */ '@/views/Dashboard')
const Login = () => import(/* webpackChunkName: 'Login' */ '@/views/Login')
const Register = () => import(/* webpackChunkName: 'Register' */ '@/views/Register')
const ConfirmEmail = () => import(/* webpackChunkName: 'ConfirmEmail' */ '@/views/ConfirmEmail')
const ConfirmTeamMember = () => import(/* webpackChunkName: 'ConfirmTeamMember' */ '@/views/ConfirmTeamMember')
const Onboarding = () => import(/* webpackChunkName: 'Onboarding' */ '@/views/Onboarding')
const UpgradePlan = () => import(/* webpackChunkName: 'UpgradePlan' */ '@/components/Billing/UpgradePlan')
import EventBus from '@/EventBus'
const Payment = () => import(/* webpackChunkName: 'Payment' */ '@/components/Billing/Payment')
const AccountDeletion = () => import(/* webpackChunkName: 'AccountDeletion' */ '@/components/Settings/AccountDeletion')
const IntegrationCallback = () => import(/* webpackChunkName: 'Integration' */ '@/components/Integrations/IntegrationCallback')
const IntegrationAuthorize = () => import(/* webpackChunkName: 'Integration' */ '@/components/Integrations/IntegrationAuthorize')
const TeamMagicLink = () => import(/* webpackChunkName: 'TeamMagicLink' */ '@/views/TeamMagicLink')
import store from '@/store'
import { isIOS } from 'mobile-device-detect'
import { isAndroid } from 'mobile-device-detect'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/check', // used in iframe, default is Dashboard but only when logged in
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        analyticsIgnore: true, // ignore matomo analytics
      },
      props: true,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        noAuth: true,
      },
      props: true,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      props(route) {
        return route.query || {}
      },
      meta: {
        noAuth: true,
      },
    },
    {
      path: '/confirm-email',
      name: 'ConfirmEmail',
      component: ConfirmEmail,
      meta: {
        noAuth: true,
      },
    },
    {
      path: '/TeamMagicLink/:token',
      name: 'TeamMagicLink',
      component: TeamMagicLink,
      meta: {
        noAuth: true,
      },
      //     beforeEnter(to, from, next) {
      //         if (isIOS){
      //             window.location = DEEPLINK_PREFIX + 'TeamMagicLink/'+to.query
      //         }
      //     }
    },
    {
      path: '/confirm-team-member',
      name: 'ConfirmTeamMember',
      component: ConfirmTeamMember,
      meta: {
        noAuth: true,
      },
    },
    {
      path: '/onboarding',
      name: 'Onboarding',
      component: Onboarding,
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
    },
    {
      path: '/upgradePlan',
      name: 'UpgradePlan',
      component: UpgradePlan,
    },
    {
      path: '/Payment',
      name: 'Payment',
      component: Payment,
      props: true,
    },
    {
      path: '/account-deletion',
      name: 'AccountDeletion',
      component: AccountDeletion,
      meta: {
        noAuth: true,
      },
      props: true,
    },
    {
      path: '/integration-callback',
      name: 'IntegrationCallback',
      component: IntegrationCallback,
      props: true,
    },
    {
      path: '/integration-authorize',
      name: 'IntegrationAuthorize',
      component: IntegrationAuthorize,
      props: true,
    },
    {
      path: '*',
      name: 'Default',
      component: Dashboard,
    },
    // ,
    // {
    //     path: '/TeamMagicLink',
    //     name: 'TeamMagicLink',
    //     component: TeamMagicLink,
    //     props: true,
    //     beforeEnter(to, from, next) {
    //         if (isIOS){
    //             window.location = DEEPLINK_PREFIX + 'TeamMagicLink/'+to.query
    //         }
    //     }
    // },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.noAuth)) {
    next() // does not require auth
  } else {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!Parse.User.current()) {
      if (to.path === '/check') {
        // if check and not logged in then do not show anything
      } else {
        next({ name: 'Login', query: to.query })
      }
    } else {
      next()
    } // go to wherever I'm going
  }
})
router.afterEach((to, from) => {
  EventBus.$emit('clear-info-bars')
  if (!store.state.preventScheduleLeave) {
    EventBus.$emit('parse-state', to.params)
    if (to.hash !== from.hash) {
      EventBus.$emit('hash-changed')
    }
  } else {
    if (store.state.pLeaveFlag) {
      store.commit('setPLeaveFlag', false)
      EventBus.$emit('leave-prevent', { to, from })
      if (!to.meta.noAuth) {
        router.push(from)
      }
    } else {
      store.commit('setPLeaveFlag', true)
    }
  }
})

export default router
